import React, { useContext, useState } from 'react';
import { BMPrimitives } from './token';
import { BMComponents, BMElevation } from './bmTokens';
/* -------------------------------------------------------------------------- */
/*                                Default Value                               */
/* -------------------------------------------------------------------------- */
const defaultTheme = {
    activeTheme: 'light',
    setTheme: () => {
        console.warn('setTheme: cannot find closest Provider. Make sure to wrap your component with <ThemeProvider /> before calling setTheme.');
    },
};
/* -------------------------------------------------------------------------- */
/*                                Theme Context                               */
/* -------------------------------------------------------------------------- */
export const BMThemeContext = React.createContext(defaultTheme);
export function BMThemeProvider({ children }) {
    const [theme, setTheme] = useState('light');
    return (<BMThemeContext.Provider value={{
            activeTheme: theme,
            setTheme,
        }}>
      {children}
    </BMThemeContext.Provider>);
}
/* -------------------------------------------------------------------------- */
/*                                 Theme Hooks                                */
/* -------------------------------------------------------------------------- */
export function useBMTheme() {
    const theme = useContext(BMThemeContext);
    const Elevation = (activeTheme = 'light') => {
        return {
            elevation1: {
                borderColor: BMElevation[activeTheme].elevation1.outline,
            },
            elevation2: {
                shadowColor: BMElevation[activeTheme].elevation2.shadow.color,
                shadowRadius: BMElevation[activeTheme].elevation2.shadow.blur,
                shadowOpacity: BMElevation[activeTheme].elevation2.shadow.opacity / 100,
                shadowOffset: {
                    width: BMElevation[activeTheme].elevation2.shadow.offset.x,
                    height: BMElevation[activeTheme].elevation2.shadow.offset.y,
                },
                // for android
                elevation: 5,
            },
        };
    };
    return {
        ...theme,
        BMPrimitives,
        BMComponents: BMComponents[theme.activeTheme],
        BMElevation: Elevation(theme.activeTheme),
    };
}
